import { ChangeDetectionStrategy, Component, forwardRef, Input, input, output, signal } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatSlideToggleChange, MatSlideToggleModule } from '@angular/material/slide-toggle';

export { MatSlideToggleChange };

@Component({
  selector: 'ts-slide-toggle',
  standalone: true,
  imports: [MatSlideToggleModule],
  templateUrl: './ts-slide-toggle.component.html',
  styleUrl: './ts-slide-toggle.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TsSlideToggleComponent),
      multi: true,
    },
  ],
})
export class TsSlideToggleComponent implements ControlValueAccessor {
  readonly color = input<'primary' | 'accent' | 'warn'>('primary');
  readonly labelPosition = input<'before' | 'after'>('after');
  readonly disabled = input(false);

  @Input() set checked(val: boolean) {
    this.value.set(!!val);
  }

  get checked(): boolean {
    return this.value();
  }

  readonly change = output<MatSlideToggleChange>();

  protected readonly value = signal(false);
  protected readonly isDisabled = signal(false);

  protected onToggleChange(event: MatSlideToggleChange): void {
    this.value.set(event.checked);
    this.onChange(event.checked);
    this.onTouched();
    this.change.emit(event);
  }

  writeValue(val: boolean): void {
    this.value.set(!!val);
  }

  registerOnChange(fn: (val: boolean) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.isDisabled.set(isDisabled);
  }

  private onChange: (val: boolean) => void = () => {};
  private onTouched: () => void = () => {};
}
